export interface LinkItem {
  title: string;
  href: string;
}

export const bTechAdmissionLinks: LinkItem[] = [
  {
    title: "Physical reporting from 20th Aug 2025 to 23rd Aug 2025",
    href: "/docs/B.Tech._Admission_Guidelines_for_2025-26_Students.pdf",
  },
  {
    title:
      "Admission form for B.Tech students allotted through JoSAA/CSAB Counselling 2025",
    href: "https://forms.gle/HhFLbufmLBh8FwW56",
  },
  {
    title: "Tution Fee Structure 2026-2027",
    href: "/docs/Tution_Fee_AY_2026_27_08042026_1713.pdf",
  },
  {
    title: "Hostel Fee Structure 2026-2027",
    href: "/docs/Hostel_Fee_AY_2026_27_080427_1714.pdf",
  },
  {
    title: "Fee Refund Policy",
    href: "/docs/Fee-Refund.pdf",
  },
  {
    title: "PM VIDYA LAXMI EDUCATION LOAN SCHEME - CANARA BANK",
    href: "/docs/PM_VIDYA_LAXMI_EDUCATION_LOAN_-CANARA_BANK_FOR_IIIT_DHARWAD.pdf",
  },
  {
    title: "Scholarships",
    href: "/scholarship/",
  },
  {
    title: "FAQ's",
    href: "/faq/",
  },
  {
    title:
      "Performance in Class XII for candidates seeking admission in IIIT Dharwad - 2026",
    href: "/docs/Performance_in%20Class_XII_2026.pdf",
  },
  {
    title:
      "Category wise Top-20 percentile cut-off marks out-of total 500 marks for 2026",
    href: "https://cdnbbsr.s3waas.gov.in/s313111c20aee51aeb480ecbd988cd8cc9/uploads/2026/06/2026060941.pdf",
  },
];

